import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CheckIcon from "@material-ui/icons/Check";
import { makeStyles } from "@material-ui/core/styles";
import useForm from "react-hook-form";
import { translator } from "../utils/i18n";
import { useDispatch, useSelector } from "react-redux";
import { searchPatients, validPresence } from "../utils/fetcher";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import ErrorIcon from "@material-ui/icons/Error";
import WaitingRoomExternal from "../app/patient-area/WaitingRoomExternal";

const useStyles = makeStyles(() => ({
  textField: {
    width: "100%"
  },
  listPatient: {
    width: "100%",
    textAlign: "center"
  }
}));

export default function ExternalUserQrCode() {
  const [checked, setChecked] = useState([]);
  const classes = useStyles();
  const dispatch = useDispatch();
  const search = values => dispatch(searchPatients(values));
  const validPresenceFunc = appointmentIds =>
    dispatch(validPresence(appointmentIds));
  const patients =
    useSelector(state => state.externalPatientsQrCode.patients) || [];
  const message = useSelector(state => state.message);
  const infosWaitingRoom = useSelector(state => state.waitingRoom) || {};

  const { handleSubmit, register } = useForm();

  const handleToggle = id => () => {
    const currentIndex = checked.indexOf(id);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(id);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const onSubmit = values => {
    search(values);
  };

  const handleClick = () => {
    validPresenceFunc(checked);
  };

  return (
    <>
      {infosWaitingRoom.gotoRoom ? (
        <div className="page-validate-qrcode justify-content-center flex-direction-column position-relative">
          <WaitingRoomExternal />
        </div>
      ) : (
        <div className="page-validate-qrcode align-items-center justify-content-center flex-direction-column">
          <form onSubmit={handleSubmit(onSubmit)}>
            <TextField
              label={translator()._("W_VOTRE_NOM")}
              variant="outlined"
              inputRef={register}
              name="rech"
              className={classes.textField}
            />
            <Button
              variant="contained"
              color="secondary"
              startIcon={<CheckIcon />}
              type="submit"
            >
              {translator()._("W_STEP_POPUP_BOUTON_OK")}
            </Button>
          </form>
          {message && (
            <div className="custom-message custom-alert d-flex align-items-center mt-15">
              <ErrorIcon />
              <div dangerouslySetInnerHTML={{ __html: message }} />
            </div>
          )}
          {patients.length > 0 && (
            <List dense className={classes.listPatient}>
              {patients.map(item => {
                const labelId = `checkbox-list-secondary-label-${
                  item.appointmentId
                }`;
                return (
                  <>
                    <ListItem
                      key={item.appointmentId}
                      button
                      onClick={handleToggle(item.appointmentId)}
                    >
                      <ListItemText
                        id={labelId}
                        primary={`${item.firstName} ${item.lastName}`}
                        secondary={`${translator()._("W_RDV_PREVU")} ${
                          item.hour
                        } ${translator()._("CP_AVEC")} ${
                          item.firstNameDoctor
                        } ${item.lastNameDoctor}`}
                      />
                      <ListItemSecondaryAction>
                        <Checkbox
                          edge="end"
                          checked={checked.indexOf(item.appointmentId) !== -1}
                          inputProps={{ "aria-labelledby": labelId }}
                          tabIndex={-1}
                          onChange={handleToggle(item.appointmentId)}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                  </>
                );
              })}
              <Button
                variant="contained"
                color="secondary"
                startIcon={<CheckIcon />}
                className="mt-15"
                onClick={handleClick}
                disabled={checked.length === 0}
              >
                {translator()._("W_VALIDER")}
              </Button>
            </List>
          )}
        </div>
      )}
    </>
  );
}
